import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import ToggleOnRoundedIcon from '@mui/icons-material/ToggleOnRounded';
import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded';
import ViewListRoundedIcon from '@mui/icons-material/ViewListRounded';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';

const FilterIcons = ({type}) => {

  let Icon = null;

  switch (type) {
    case 'date':
      Icon =  CalendarMonthOutlinedIcon
      break;
    case 'balance':
      Icon =  AccountBalanceWalletOutlinedIcon
      break;
    case 'boolean':
      Icon =  ToggleOnRoundedIcon
      break;
    case 'list':
    case 'autoMulti':
      Icon =  ListAltOutlinedIcon
      break;
    default:
      Icon =  FilterListRoundedIcon
  }

  return <Icon fontSize='small' color="secondary" />
};

export default FilterIcons;